<template>
  <AttrImage
    class="mt-2.5"
    :tooltip="tooltip"
    label="上传预览图"
    :base64="previewImage"
    :disabled="(multiColor ? false : !!attrDisabled) || disabled"
    @change="(imagePath:string) => onImageUpload(imagePath)"
    @delete="() => onImageDelete()"
  />
</template>

<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { ResourceKey } from '@/services/shape/attributes';
import { useEditorStore } from '@/store/use-editor-store';
import { getImageSize } from '@/utils/fs/image.utils';
import { computed, PropType } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  tooltip: {
    type: String,
    default: '预览图为必传'
  },
  previewKey: {
    type: String as PropType<ResourceKey>,
    required: true
  },
  // 是否多配色
  multiColor: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const colorId = computed(() => {
  const val = props.multiColor
    ? editorStore.themeColor?.id
    : editorStore.theme?.colorGroupTable?.[0]?.id;

  return val ?? '';
});

const previewImage = computed(() => {
  return props.shape.getResources({
    resourceName: props.previewKey,
    // 这里仅显示第一个配色的预览图，其他配色不可修改预览图
    colorGroup: colorId.value,
    base64: true
  })?.[0];
});
const onImageUpload = async (imagePath: string) => {
  const { w, h } = props.shape.attrs;
  await props.shape?.uploadResource({
    resourceName: props.previewKey,
    colorGroup: colorId.value,
    realpath: imagePath
  });
  const size = await getImageSize(imagePath);
  if (size && (size.width !== w || size.height !== h)) {
    props.shape.setAttrs({
      w: size.width,
      h: size.height
    });
  }
};
const onImageDelete = () => {
  props.shape?.deleteResource({
    resourceName: props.previewKey,
    colorGroup: colorId.value
  });
};
</script>
